import { render, staticRenderFns } from "./SwitchTable.vue?vue&type=template&id=bb9a072e&scoped=true"
import script from "./SwitchTable.vue?vue&type=script&lang=js"
export * from "./SwitchTable.vue?vue&type=script&lang=js"
import style0 from "./SwitchTable.vue?vue&type=style&index=0&id=bb9a072e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9a072e",
  null
  
)

export default component.exports